/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */

/**
 * Operational health faults (distinct from pause time-accounting).
 */
export type OralExamOperationalFault = (typeof OralExamOperationalFault)[keyof typeof OralExamOperationalFault];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const OralExamOperationalFault = {
  student_disconnected: 'student_disconnected',
  agent_failed: 'agent_failed',
  recording_failed: 'recording_failed',
  failover_required: 'failover_required',
  session_expired: 'session_expired',
} as const;
